import { IStaticDataValue } from "@curefit/care-common"
import { SelectProps } from "antd"

export enum WATCHMEN_RESOURCES {
	WELCOME_PAGE = "WELCOME_PAGE",
	CALENDAR = "CALENDAR",
	PATIENT_LIST = "PATIENT_LIST",
	ROSTER = "ROSTER",
	DOCTOR_PROFILE = "DOCTOR_PROFILE",
	AUTOMATED_ROSTER = "AUTOMATED_ROSTER",
	TREATMENT_PLAN = "TREATMENT_PLAN",
	TREATMENT_PLAN_EDITOR = "TREATMENT_PLAN_EDITOR",
	MEAL_PLAN = "MEAL_PLAN",
	ODIN = "ODIN",
	TASK = "TASK",
	DOCTOR_CONSULT_LIST = "DOCTOR_CONSULT_LIST",
	PATIENT_DETAILS = "PATIENT_DETAILS",
	CATALOGUE = "CATALOGUE",

	/*
	 * LEFT NAV RESOURCES
	 * */

	PATIENT_PROFILE = "PATIENT_PROFILE",
	PATIENT_CONSULTATIONS = "PATIENT_CONSULTATIONS",
	PSYCHOLOGIST_CONSULTATIONS = "PSYCHOLOGIST_CONSULTATIONS",
	PATIENT_CONSULTATIONS_DETAILS = "PATIENT_CONSULTATIONS_DETAILS",
	DOCTOR_ONGOING_CONSULT = "DOCTOR_ONGOING_CONSULT",
	EDIT_DOCTOR_CONSULT = "EDIT_DOCTOR_CONSULT",
	COACH_ONGOING_CONSULT = "COACH_ONGOING_CONSULT",
	EDIT_COACH_CONSULT = "EDIT_COACH_CONSULT",
	PATIENT_LIFESTYLE_RECALL = "PATIENT_LIFESTYLE_RECALL",
	PATIENT_ACTIVE_PLAN = "PATIENT_ACTIVE_PLAN",
	PATIENT_ADHERENCE = "PATIENT_ADHERENCE",
	PATIENT_CGM_ACT = "PATIENT_CGM_ACT",
	PATIENT_DAILY_ACT = "PATIENT_DAILY_ACT",
	PATIENT_FITNESS_DATA = "PATIENT_FITNESS_DATA",
	PATIENT_GLUCOSE = "PATIENT_GLUCOSE",
	PATIENT_LAB_TEST = "PATIENT_LAB_TEST",
	PATIENT_VITALS = "PATIENT_VITALS",
	PATIENT_GOALS = "PATIENT_GOALS",
	PATIENT_DOCUMENT = "PATIENT_DOCUMENT",
	PATIENT_HISTORY = "PATIENT_HISTORY",
	PATIENT_NOTES = "PATIENT_NOTES",
	CHALLENGES = "CHALLENGES",
	CHALLENGES_CREATE = "CHALLENGES_CREATE",
	CHALLENGES_DETAILS = "CHALLENGES_DETAILS",
	POLLS = "POLLS",
	POLL_CREATE = "POLL_CREATE",
	POLL_DETAILS = "POLL_DETAILS",
	LINKS_LIBRARY = "LINKS_LIBRARY",
	EXPERIMENTS = "EXPERIMENTS",

	/*
	 * Doctor Consult
	 */

	PRESCRIPTION_HISTORY = "PRESCRIPTION_HISTORY",
	EXAMINATION = "EXAMINATION",
	PRESCRIPTION = "PRESCRIPTION",
	RCA = "RCA",
	RCA_EDIT = "RCA_EDIT",
	REQUESTS = "REQUESTS",
	METRICS = "METRICS",
	CONSULT_TRANSCRIPT_RECORDING = "CONSULT_TRANSCRIPT_RECORDING",
	PSYCHOLOGIST_CONSULT_AUDIO_RECORDING = "PSYCHOLOGIST_CONSULT_AUDIO_RECORDING",
	PSYCHOLOGIST_CONSULT_TRANSCRIPTION = "PSYCHOLOGIST_CONSULTTRANSCRIPTIONG",
	CONSULT_RATING = "CONSULT_RATING",
}

export enum ACCESS_TYPES {
	CREATE = "CREATE",
	READ = "READ",
	UPDATE = "UPDATE",
	DELETE = "DELETE",
}

export const WATCHMEN_CONTEXT = {
	ALL: "all",
}

export enum DoctorTypes {
	LIFESTYLE_COACH = "LIFESTYLE_COACH",
	DOCTOR = "DOCTOR",
	SF_PSYCHIATRIST = "SF_PSYCHIATRIST",
	GLP_NURSE = "GLP_NURSE",
}

export enum ROLE_NAMES {
	ADMIN = "ADMIN",
	DOCTOR = "DOCTOR",
	ULTRAFIT = "ULTRAFIT",
	COMMUNITY_MANAGER = "COMMUNITY_MANAGER",
	SF_CHAT = "SF_CHAT",
	CONVERSE_CHAT = "CONVERSE_CHAT",
}

export enum AppTenants {
	SUGARFIT = "SUGARFIT",
	ULTRAFIT = "ULTRAFIT",
	CUREFIT = "CUREFIT",
}

export const LiveClassDeeplinkBaseUrl = "curefit://liveclassdetail?liveClassId=$classProductId&bookingNumber=$classProductId&productType=LIVE_FITNESS&isDIY=true&packId=$packProductId"

export const ORION_S3_BASE_URL_V1 = "https://cdn-media.cure.fit/image/sugarfit-orion/v1"

export const INTERVENTIONS_BASE_URL = ORION_S3_BASE_URL_V1 + "/interventions/"

export const LEFT_NAV_ICONS_BASE_URL = ORION_S3_BASE_URL_V1 + "/left-nav-icons/"

export const URLS = { CDN_URL: "https://d1yfs1c2pfwbpr.cloudfront.net", SF_CDN_URL: "https://d30nc97kamtr39.cloudfront.net" }
export const ORION_IMG_URL = URLS.CDN_URL + "/image/carefit/orion/"
export const SF_SYNAPSE_ASSETS_URL = URLS.SF_CDN_URL + "/synapse-assets"

export const ORION_S3_IMAGES = {
	CHAT_UNREAD: ORION_S3_BASE_URL_V1 + "/chat-unread.svg",
	CHAT_FILTER: ORION_S3_BASE_URL_V1 + "/chat-filter.svg",
	FILTER_SOLID: ORION_S3_BASE_URL_V1 + "/filter-solid.svg",
	CHECKBOX_ACTIVE: ORION_S3_BASE_URL_V1 + "/checkbox-active.svg",
	CHAT_ACTIVE: ORION_S3_BASE_URL_V1 + "/chat-active.svg",
	CHAT_BLUE: ORION_S3_BASE_URL_V1 + "/chat-blue.svg",
	ERROR_PLACEHOLDER: ORION_S3_BASE_URL_V1 + "/error_placeholder.svg",
	PINK_CALENDER: ORION_S3_BASE_URL_V1 + "/pink-calender.svg",

	CALENDER: ORION_S3_BASE_URL_V1 + "/calender-grey.svg",
	LIVE_CLASS_BOXES: ORION_S3_BASE_URL_V1 + "/live-classes-boxes.svg",
	NO_RESPONSE: ORION_S3_BASE_URL_V1 + "/no-response.svg",
	DONE: ORION_S3_BASE_URL_V1 + "/done.svg",
	NOT_DONE: ORION_S3_BASE_URL_V1 + "/not-done.svg",
	UPCOMING: ORION_S3_BASE_URL_V1 + "/upcoming.svg",
	ALMOST_DONE: ORION_S3_BASE_URL_V1 + "/almost-done.svg",

	NO_GOAL_PLACEHOLDER: ORION_S3_BASE_URL_V1 + "/no-goal-placeholder.svg",
	STATUS_MISSED: ORION_S3_BASE_URL_V1 + "/status-missed.svg",
	STATUS_ACTIVE: ORION_S3_BASE_URL_V1 + "/status-active.svg",
	STATUS_INACTIVE: ORION_S3_BASE_URL_V1 + "/status-inactive.svg",

	FIRE: ORION_S3_BASE_URL_V1 + "/fire.svg",
	THUNDER: ORION_S3_BASE_URL_V1 + "/thunder.svg",
	HEART: ORION_S3_BASE_URL_V1 + "/heart.svg",
	LOCATION_PIN: ORION_S3_BASE_URL_V1 + "/location-pin.svg",
	STEPS: ORION_S3_BASE_URL_V1 + "/steps.svg",
	STAIRS: ORION_S3_BASE_URL_V1 + "/stairs.svg",
	MOON: ORION_S3_BASE_URL_V1 + "/moon.svg",
	FOUR_DOTS: ORION_S3_BASE_URL_V1 + "/four-dots.svg",
	GREY_ADD_NEW: ORION_S3_BASE_URL_V1 + "/grey-add-new.svg",
	MEAL_SLOTS: ORION_S3_BASE_URL_V1 + "/meal-slots.svg",
	PINK_ADD_NEW: ORION_S3_BASE_URL_V1 + "/pink-add-new.svg",
	ADD_NEW_LIGHT: ORION_S3_BASE_URL_V1 + "/add-new-light.svg",
	WHITE_ADD_NEW_LIGHT: ORION_S3_BASE_URL_V1 + "/white-add-new-light.svg",
	TEMPLATE_BLACK: ORION_S3_BASE_URL_V1 + "/template-black.svg",
	MAXIMIZE: ORION_S3_BASE_URL_V1 + "/maximize.svg",
	TAG: ORION_S3_BASE_URL_V1 + "/tags.svg",
	PINK_BULB: ORION_S3_BASE_URL_V1 + "/pink-bulb.svg",

	NUTRITION: INTERVENTIONS_BASE_URL + "nutrition.svg",

	BEFORE_CONSULTATION: ORION_S3_BASE_URL_V1 + "/calendar-icon.svg",
	DOCUMENT_IMAGE: ORION_S3_BASE_URL_V1 + "/document-image.svg",
	KISKSTARTER: ORION_S3_BASE_URL_V1 + "/kiskstarter.svg",
	NEW: ORION_S3_BASE_URL_V1 + "/new-tag.svg",
	PDF: ORION_S3_BASE_URL_V1 + "/pdf.svg",
	MAXIMIZE_WHITE: ORION_S3_BASE_URL_V1 + "/maximize-white.svg",
	THUMBNAIL: ORION_S3_BASE_URL_V1 + "/thumbnail.svg",
	LIST: ORION_S3_BASE_URL_V1 + "/list-icon.svg",
	WHATSAPP: ORION_S3_BASE_URL_V1 + "/whatsapp.svg",
	SETTINGS: ORION_S3_BASE_URL_V1 + "/settings.svg",

	EMPTY_BOX: ORION_S3_BASE_URL_V1 + "/empty-box.svg",
	CLASS_RESET_PINK: ORION_S3_BASE_URL_V1 + "/class-reset-pink.svg",
	COMMUNITY_START_CONVERSATION: ORION_S3_BASE_URL_V1 + "/community-start-conversation-bg.png",

	ACTIVITIES: ORION_S3_BASE_URL_V1 + "/activities.svg",
	ADHERENCE_CALENDER: ORION_S3_BASE_URL_V1 + "/adherence-calender.svg",
	CGM: ORION_S3_BASE_URL_V1 + "/cgm.svg",
	GLUCOSE_DROP: ORION_S3_BASE_URL_V1 + "/glucose-drop.svg",
	LAB_TEST: ORION_S3_BASE_URL_V1 + "/lab-test.svg",
	NOTES_EDIT: ORION_S3_BASE_URL_V1 + "/notes-edit.svg",
	VITALS: ORION_S3_BASE_URL_V1 + "/vitals.svg",
	PAST_CONSULTATIONS: ORION_S3_BASE_URL_V1 + "/past-consultations.svg",
	FITNESS_DATA: ORION_S3_BASE_URL_V1 + "/fitness-data.svg",
	CONSULT_CHECKLIST: ORION_S3_BASE_URL_V1 + "/consult_instructions.svg",
	CONSULT_PRECAP: ORION_S3_BASE_URL_V1 + "/consult-precap.png",

	AIRPLAY: ORION_S3_BASE_URL_V1 + "/airplay.svg",
	VIDEO: ORION_S3_BASE_URL_V1 + "/video.svg",
	VIDEO_OFF: ORION_S3_BASE_URL_V1 + "/video-off.svg",
	MIC: ORION_S3_BASE_URL_V1 + "/mic.svg",
	MIC_OFF: ORION_S3_BASE_URL_V1 + "/mic-off.svg",
	PHONE_OFF: ORION_S3_BASE_URL_V1 + "/phone-off.svg",
	BLUR_OFF: ORION_S3_BASE_URL_V1 + "/blur_off.svg",
	BLUR_ON: ORION_S3_BASE_URL_V1 + "/blur_on.svg",

	NON_SERVICEABLE_AREA: ORION_S3_BASE_URL_V1 + "/ops-journey/non-serviceable.svg",
	DIAGNOSTIC_BENEFIT_EXHAUSTED: ORION_S3_BASE_URL_V1 + "/ops-journey/diagnostic-benefits-exhausted.svg",
	DOCTOR_CONSULATAION_BENEFIT_EXHAUSTED: ORION_S3_BASE_URL_V1 + "/ops-journey/doctor-consult-exhausted.svg",
	SLOT_BOOKING_SUCCESS: ORION_S3_BASE_URL_V1 + "/ops-journey/slot-booking-success.svg",

	MOBILE_STATUS_BAR: ORION_S3_BASE_URL_V1 + "/mobile-status-bar.svg",
	VOTE_BARS: ORION_S3_BASE_URL_V1 + "/vote-bars.svg",
	INFO_ICON: ORION_S3_BASE_URL_V1 + "/info-icon.svg",
	SURVEY: ORION_S3_BASE_URL_V1 + "/survey.svg",

	IMAGE_ICON: ORION_S3_BASE_URL_V1 + "/image-icon.svg",
	MENU_DOTS: ORION_S3_BASE_URL_V1 + "/menu-dots.svg",
	FALLBACK_IMAGE: ORION_S3_BASE_URL_V1 + "/fallback-image.png",
	ARROW_DROP_DOWN: ORION_S3_BASE_URL_V1 + "/arrow-drop-down.svg",

	SUGARFIT_LOGO_LIGHT: ORION_S3_BASE_URL_V1 + "/sugarfit-logo.svg",
	SUGARFIT_LOGO_DARK: ORION_S3_BASE_URL_V1 + "/sugarfit-logo.svg",
	REMOVE_ICON: ORION_S3_BASE_URL_V1 + "/remove-icon.svg",
	PUBLISHED_POLL: ORION_S3_BASE_URL_V1 + "/poll-published.svg",
	EMPTY_STATE_ICON: ORION_S3_BASE_URL_V1 + "/empty-state-icon.svg",

	BODY_PARTS_FRONT: ORION_S3_BASE_URL_V1 + "/body-parts-front.svg",
	BODY_PARTS_BACK: ORION_S3_BASE_URL_V1 + "/body-parts-back.svg",
	INDIVIDUAL_CHALLENGE: ORION_S3_BASE_URL_V1 + "/individual-challenge.svg",
	GROUP_V_GROUP_CHALLENGE: ORION_S3_BASE_URL_V1 + "/group-v-group-challenge.svg",
	GROUP_CHALLENGE: ORION_S3_BASE_URL_V1 + "/group-challenge.svg",
	VIDEO_BOX: ORION_S3_BASE_URL_V1 + "/video-box.svg",
	VOLT: ORION_S3_BASE_URL_V1 + "/volt.svg",

	OUTLINE_DONE: ORION_S3_BASE_URL_V1 + "/outlined-done.svg",
	PENDING_ICON: ORION_S3_BASE_URL_V1 + "/pending-icon.svg",
	VIDEO_CAMERA: ORION_S3_BASE_URL_V1 + "/video-camera.svg",

	CONNECTIVITY_STATUS: {
		POOR: ORION_S3_BASE_URL_V1 + "/connectivity_status_poor.svg",
		GOOD: ORION_S3_BASE_URL_V1 + "/connectivity_status_good.svg",
		MEDIUM: ORION_S3_BASE_URL_V1 + "/connectivity_status_medium.svg",
	},
	VIDEO_CALL_BACKGROUNDS: {
		1: ORION_S3_BASE_URL_V1 + "/sugarfit-wall-bg.jpg",
		2: ORION_S3_BASE_URL_V1 + "/sugarfit-wall-2-bg.jpg",
	},
	BG_BLUR_ICON: ORION_S3_BASE_URL_V1 + "/bg-blur.svg",
	BG_REPLACE: ORION_S3_BASE_URL_V1 + "/bg-replace.svg",
	NO_BLUR: ORION_S3_BASE_URL_V1 + "/no-blur.svg",
	VIDEO_STATUS: {
		ON: ORION_S3_BASE_URL_V1 + "/video-on-v2.svg",
		OFF: ORION_S3_BASE_URL_V1 + "/video-off-v2.svg",
	},
	AUDIO_STATUS: {
		ON: ORION_S3_BASE_URL_V1 + "/audio-on-v2.svg",
		OFF: ORION_S3_BASE_URL_V1 + "/audio-off-v2.svg",
	},
	SCREEN_SHARE_STATUS: {
		ON: ORION_S3_BASE_URL_V1 + "/screen-share-on.svg",
		OFF: ORION_S3_BASE_URL_V1 + "/screen-share-off.svg",
	},
	END_CALL: ORION_S3_BASE_URL_V1 + "/end-call.svg",
	DOCTOR_AVATAR: ORION_S3_BASE_URL_V1 + "/doctor-avatar.svg",
	FBV: {
		HEART_BEAT: ORION_S3_BASE_URL_V1 + "/fbv-heart-beat.svg",
		HEART_RATE: ORION_S3_BASE_URL_V1 + "/fbv-heart-rate.svg",
		OXYGEN: ORION_S3_BASE_URL_V1 + "/fbv-oxygen.svg",
		RESPIRATORY_RATE: ORION_S3_BASE_URL_V1 + "/fbv-respiratory-rate.svg",
		STRESS: ORION_S3_BASE_URL_V1 + "/fbv-stress.svg",
	},
	PDF_BANNER: {
		CGM: ORION_S3_BASE_URL_V1 + "/banner-cgm.svg",
		CONSULT: ORION_S3_BASE_URL_V1 + "/banner-consult.svg",
		HEART: ORION_S3_BASE_URL_V1 + "/banner-heart.svg",
		INSIGHTS: ORION_S3_BASE_URL_V1 + "/banner-insight.svg",
		PLAN: ORION_S3_BASE_URL_V1 + "/banner-plans.svg",
		TECH: ORION_S3_BASE_URL_V1 + "/banner-tech.svg",
		DISCOUNT: ORION_S3_BASE_URL_V1 + "/banner-discount.svg",
	},
	PACK_PURCHASE_BANNER: ORION_S3_BASE_URL_V1 + "/pack-purchase-banner.jpg",
	PACK_PURCHASE_BANNER_V1: ORION_S3_BASE_URL_V1 + "/pack-purchase-banner-v1.jpg",
	SAMPLE_GRAPH_1_DARK: ORION_S3_BASE_URL_V1 + "/sample_graph_1_dark.webp",
	SAMPLE_GRAPH_2_DARK: ORION_S3_BASE_URL_V1 + "/sample_graph_2_dark.webp",
	SAMPLE_GRAPH_1_LIGHT: ORION_S3_BASE_URL_V1 + "/sample_graph_1_light.webp",
	SAMPLE_GRAPH_2_LIGHT: ORION_S3_BASE_URL_V1 + "/sample_graph_2_light.webp",
	DIALING_AUDIO: ORION_S3_BASE_URL_V1 + "/dial-ringing.mp3",
	CALL_WAITING_AUDIO: ORION_S3_BASE_URL_V1 + "/call-waiting-voice.mp3",
	GLP_PROGRAM_ICON: SF_SYNAPSE_ASSETS_URL + "/syringe-icon.jpg",
}

export enum Themes {
	DARK = "DARK",
	LIGHT = "LIGHT",
}

export enum RoleNames {
	ADMIN = "ADMIN",
	DOCTOR = "DOCTOR",
	ULTRAFIT = "ULTRAFIT",
	COMMUNITY_MANAGER = "COMMUNITY_MANAGER",
	SF_CHAT = "SF_CHAT",
	CONVERSE_CHAT = "CONVERSE_CHAT",
	BLOCK_USER = "BLOCK_USER",
	PSYCHOLOGIST = "PSYCHOLOGIST",
}

export enum SupportedDoctorTypes {
	LIFESTYLE_COACH = "LIFESTYLE_COACH",
	DOCTOR = "DOCTOR",
}

export enum ConsultDoctorType {
	LC = "LC",
	GP = "GP",
	GLP_NURSE = "GLP_NURSE",
}

export const DEFAULT_REACT_USE_QUERY_OPTIONS = {
	retry: false,
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
}

export enum PreferenceTypeAttributeEnum {
	LANGUAGE = "language",
	ADDRESS_ID = "addressId",
	DOCTOR_CONSULTATION_CHECK = "doctorConsultationCheck",
}

export enum CoachRequestStatus {
	APPROVED = "APPROVED",
	PENDING = "PENDING",
	REJECTED = "REJECTED",
}

export enum ChronicCareSubscriptionStatus {
	ACTIVE = "ACTIVE",
	UPCOMING = "UPCOMING",
	EXPIRED = "EXPIRED",
}

export enum BroadcastChannelNames {
	TASK_COMPLETE_CALENDER_REFRESH = "TASK_COMPLETE_CALENDER_REFRESH",
}

export enum ValidateTaskDisposalStatusCode {
	INSUFFICIENT_CALL_DURATION = "INSUFFICIENT_CALL_DURATION",
	INSUFFICIENT_CALL_ATTEMPTS = "INSUFFICIENT_CALL_ATTEMPTS",
	MISSING_FOLLOWUP_TASK = "MISSING_FOLLOWUP_TASK",
	CREATE_FOLLOWUP_TASK = "CREATE_FOLLOWUP_TASK",
	RESCHEDULED = "RESCHEDULED",
	TASK_PROFILE_INCOMPLETE = "TASK_PROFILE_INCOMPLETE",
}

export enum ClinicalProgress {
	PROGRESS = "Progress",
	NO_PROGRESS = "No Progress",
	SUB_OPTIMAL = "Sub Optimal",
}

export const ODIN_NAMESPACE = "xray"

export const ODIN_FETCH_PER_REQUEST_LIMIT = 5
export const TICKET_CONVERSATION_DEFAULT_LIMIT = 50

interface IRole {
	active: boolean
	context: string
	id: number
	namespace: string
	roleName: string
	userId: string
}

export enum TICKET_CONVERSATION_USER_TYPE_ENUM {
	AGENT = "AGENT",
	USER = "USER",
}

export enum SortOrder {
	ASCENDING = "ASC",
	DESCENDING = "DESC",
}

export const ConsultationModes: { [key: string]: any } = {
	ONLINE: { id: "ONLINE", display: "Online" },
	OFFLINE: { id: "OFFLINE", display: "In Center" },
	INCENTRE: { id: "INCENTRE", display: "In Center" },
}

export enum ConsultationStatusConstant {
	WAITING_FOR_CONFIRMATION = "WAITING_FOR_CONFIRMATION",
	BOOKED = "BOOKED",
	SCHEDULED = "SCHEDULED",
	MISSED = "MISSED",
	CUSTOMER_MISSED = "CUSTOMER_MISSED",
	ARRIVED_INCENTRE = "ARRIVED_INCENTRE",
	VITALS_COLLECTED = "VITALS_COLLECTED",
	CALL_REMINDER = "CALL_REMINDER",
	CONSULTATION_STARTED = "CONSULTATION_STARTED",
	ONGOING = "ONGOING",
	PRESCRIPTION_GENERATED = "PRESCRIPTION_GENERATED",
	EDIT_PRESCRIPTION_GENERATED = "EDIT_PRESCRIPTION_GENERATED",
	PRESCRIPTION_IN_DRAFT = "PRESCRIPTION_IN_DRAFT",
	CONSULTATION_COMPLETED = "CONSULTATION_COMPLETED",
	EDIT_PRESCRIPTION_COMPLETED = "EDIT_PRESCRIPTION_COMPLETED",
	CANCELLED = "CANCELLED",
	RESCHEDULED = "RESCHEDULED",
	COMPLETED = "COMPLETED",
	DOCTOR_UNAVAILABLE = "DOCTOR_UNAVAILABLE",
}

export const ALL = "ALL"

export const HourCellMaxHeightInPixel = 220
// export const CAL_HOUR_CELL_HEIGHT_IN_PIXEL = 95;

export const ConsultationStatus: { [key: string]: string } = {
	WAITING_FOR_CONFIRMATION: "Awaiting confirmation",
	BOOKED: "Booked",
	SCHEDULED: "Scheduled",
	ARRIVED_INCENTRE: "Arrived @centre",
	VITALS_COLLECTED: "Vitals collected",
	CALL_REMINDER: "Call reminder",
	CONSULTATION_STARTED: "Consultation started",
	ONGOING: "Ongoing",
	PRESCRIPTION_GENERATED: "Prescription generated",
	PRESCRIPTION_IN_DRAFT: "Prescription in draft",
	CONSULTATION_COMPLETED: "Consultation completed",
	EDIT_PRESCRIPTION_GENERATED: "Edited Prescription generated",
	EDIT_PRESCRIPTION_COMPLETED: "Edited Prescription completed",
	CANCELLED: "Cancelled",
	RESCHEDULED: "Resceduled",
	COMPLETED: "Completed",
	MISSED: "Missed",
	CUSTOMER_MISSED: "Customer Missed",
}

export const ALLOWED_ACTIONS = {
	START_CONSULTATION: "START_CONSULTATION",
	EDIT_CONSULTATION: "EDIT_CONSULTATION",
}

export const AppSources: string[] = ["WEBSITE", "APP"]

export enum ShiftStatus {
	ACTIVE = "ACTIVE",
	TEMP_INACTIVE = "TEMP_INACTIVE",
	INACTIVE = "INACTIVE",
	PREVIEW = "PREVIEW",
}

export enum RosterSlotEditType {
	EDIT = "EDIT",
	ADD = "ADD",
	COPY = "COPY",
}

export const WEEKDAYS: { [key: string]: any } = {
	Monday: { label: "Monday", value: "MONDAY", momentDayValue: "Monday", shortForm: "Mon" },
	Tuesday: { label: "Tuesday", value: "TUESDAY", momentDayValue: "Tuesday", shortForm: "Tue" },
	Wednesday: { label: "Wednesday", value: "WEDNESDAY", momentDayValue: "Wednesday", shortForm: "Wed" },
	Thursday: { label: "Thursday", value: "THURSDAY", momentDayValue: "Thursday", shortForm: "Thu" },
	Friday: { label: "Friday", value: "FRIDAY", momentDayValue: "Friday", shortForm: "Fri" },
	Saturday: { label: "Saturday", value: "SATURDAY", momentDayValue: "Saturday", shortForm: "Sat" },
	Sunday: { label: "Sunday", value: "SUNDAY", momentDayValue: "Sunday", shortForm: "Sun" },
}

export const MonthNames = [
	{
		label: "January",
		value: "January",
	},
	{
		label: "February",
		value: "February",
	},
	{
		label: "March",
		value: "March",
	},
	{
		label: "April",
		value: "April",
	},
	{
		label: "May",
		value: "May",
	},
	{
		label: "June",
		value: "June",
	},
	{
		label: "July",
		value: "July",
	},
	{
		label: "August",
		value: "August",
	},
	{
		label: "September",
		value: "September",
	},
	{
		label: "October",
		value: "October",
	},
	{
		label: "November",
		value: "November",
	},
	{
		label: "December",
		value: "December",
	},
]

export enum DisplayMode {
	VIEW = "VIEW",
	EDIT = "EDIT",
}

export enum CallJoinUnJoinEventName {
	DOCTOR_JOINED_CALL = "DOCTOR_JOINED_CALL",
	DOCTOR_UNJOINED_CALL = "DOCTOR_UNJOINED_CALL",
	DOCTOR_AUTO_UNJOINED_CALL = "DOCTOR_AUTO_UNJOINED_CALL",
}

export const VitalsEditSourceName = "DOCSAPP"
export const SynapseSourceName = "ORION"

export const metricIdsToFetchMetrics = [20, 56, 3, 57, 58, 59, 60, 61, 45, 25, 2, 1]
export const metricNamesToFetchMetrics = [
	"Waist-Hip Ratio",
	"Pulse Rate",
	"Weight",
	"Hip",
	"SPO2",
	"Respiratory Rate",
	"Body Temperature",
	"Waist",
	"Diastolic BP",
	"Systolic BP",
	"Height",
	"BMI"
]

export enum CustomEventNames {
	UPDATE_PAGE_DATA_STORE = "UPDATE_PAGE_DATA_STORE",
	DOCTOR_CONSULT_TAB_SWITCH = "DOCTOR_CONSULT_TAB_SWITCH",
	RE_FETCH_SEARCH_SUGGESTION = "RE_FETCH_SEARCH_SUGGESTION",
	SHOW_MODAL = "SHOW_MODAL",
	HIDE_MODAL = "HIDE_MODAL",
	/** Fired by the Medication section every time the local medicine list changes
	 *  (add / remove / edit). Lets cross-section reactive logic — e.g. the
	 *  Advices section's GLP-1 auto-toggle — update instantly without waiting for
	 *  the 15-second autosave to flush local state into Redux. */
	MEDICINE_LIST_CHANGED = "MEDICINE_LIST_CHANGED",
}

export enum APPOINTMENT_ORDER_LOG_EVENT_TYPE_ENUM {
	DOCTOR_JOINED_CALL = "DOCTOR_JOINED_CALL",
	PATIENT_JOINED_CALL = "PATIENT_JOINED_CALL",
}

export const ALLOW_START_BUTTON_STATUSES = ["CONSULTATION_STARTED", "PRESCRIPTION_IN_DRAFT"]

export enum RequestAudioRecordingStatuses {
	REQUESTING = "REQUESTING",
	SUCCESS = "SUCCESS",
	FAILED = "FAILED",
	INITIAL = "INITIAL",
}

export const SLOW_NETWORK_THRESHOLD = 2
export enum VideoCallSDKs {
	TWILIO = "TWILIO",
	HMS = "HMS",
}

export enum MissedReasonCode {
	SYSTEM = "SYSTEM",
}

export const UpdateAppointmentStatusTimeoutInSeconds = 5

export enum LoadingState {
	NOT_INITIALIZED,
	LOADING,
	LOADED,
}

export const MedicineInstructionCodes: { [key: string]: string } = {
	SOS: "As and when required",
	BEFORE_SLEEP: "Before sleep",
	BELOW_THE_TONGUE: "Below the tongue",
	BEFORE_FOOD: "Before food",
	AFTER_FOOD: "After food",
	EMPTY_STOMACH: "Empty stomach",
	CHEWABLE: "Chewable",
	PER_ORAL: "Per Oral",
	INTRADERMAL_INJECTION: "Intradermal Injection",
	INTRAMUSCULAR: "Intramuscular",
	INTRAVENOUS: "Intravenous",
	SUBCUTANEOUS: "Subcutaneous",
	NASAL_SPRAY: "Nasal Spray",
	PER_VAGINAL: "Per Vaginal",
	PER_RECTUM: "Per Rectum",
	LOCAL_APPLICATION: "Local Application",
	SUBLINGUAL: "Sublingual",
	TRANSDERMAL: "Transdermal",
	ANYTIME: "Anytime",
}

export enum GoalMeasureFrequencyType {
	EVERY_DAY = "Every Day",
	EVERY_ALTERNATE_DAY = "Every Alternate Day",
	EVERY_WEEK = "Every Week",
	EVERY_FORTNIGHT = "Every Fortnight",
	EVERY_MONTH = "Every Month",
	EVERY_3_MONTH = "Every 3 Month",
}

export const PrescriptionPdfSection = {
	ALLERGIES: "allergies",
	VITALS: "vitals",
	CHIEF_SYMPTOMS: "chiefSymptoms",
	PUBLIC_NOTES: "publicNotes",
	CURRENT_VISIT_SUMMARY: "currentVisitSummary",
	DIAGNOSIS: "diagnosis",
	GENERAL_EXAMINATIONS: "generalExaminations",
	ENT_EXAMINATIONS: "entExaminations",
	SYSTEMIC_EXAMINATIONS: "systemicExaminations",
	LAB_TESTS: "labTest",
	MEDICINES: "medicines",
	GENERAL_ADVICE: "adviceTemplate",
	LIFESTYLE_ADVICE: "lifestyleAdvice",
	REFERRAL: "referral",
	FOLLOWUP: "followUp",
	PROVISIONAL_DIAGNOSIS: "provisionalDiagnosis",
	GOALS: "physioGoals",
	PROVISIONAL_TREATMENT_PLAN: "provisionalTreatmentPlan",
	POST_SESSION_ADVICE: "postSessionAdvice",
	ACTIVITY_RECOMMENDATION_STRETCHING: "activityRecommendation-stretching",
	ACTIVITY_RECOMMENDATION_STRENGTHENING: "activityRecommendation-strengthening",
	ACTIVITY_RECOMMENDATION_WORKOUT: "activityRecommendation-workout",
	// PHYSIO_LAB_TEST: "prescriptionLabTest",
	ADDITIONAL_ADVICE: "additionalAdvice",
	PHYSIO_REFERRAL: "physioReferral",
	PHYSIO_FOLLOWUP: "physioFollowUp",
	PHYSIO_LAB_TEST: "physioLabTest",
	BODY_PARTS: "bodyPartsCateredTo",
	PATIENT_GOALS: "patientGoals",
	PATIENT_ADHERENCE: "patientAdherence",

	// offline experience sections
	PATIENT_AND_DOCTOR_INFO: "patientAndDoctorInfo",
	PATIENT_VITALS: "patientVitals",
	HEALTH_OVERVIEW: "healthOverview",
	GOALS_AND_RECOMMENDATIONS: "goalRecommendation",
	CONDITION_ASSESSMENT: "conditionAssessment",
	FACE_BASED_VITALS: "faceBasedVitals",
	ACTIVE_FOODS_RECOMMENDATIONS: "prescriptionActiveFoodsRecommendations",
	DOCTOR_SIGNATURE: "doctorSignature",
	BUNDLE_BANNER: "bundlePack",
}

// 1123 = currentVisitSummary (GLP-1 contraindication screening) — placed
// immediately after publicNotes (113) so it renders right below the doctor's
// public notes in the prescription PDF.
export const InCenterPrescriptionPdfTemplateIds = [1114, 1115, 1118, 1117, 113, 1123, 6, 8, 21, 1122, 18, 2, 19, 10, 25, 1120] //ids of sections for in-center prescription
export const PrescriptionPdfTemplateIds = [1114, 1113, 113, 1123, 6, 8, 21, 1122, 18, 2, 19, 10, 25, 1120] //ids of sections for regular prescription

export const CONSULTATION_DELAY_HOOKS_IN_MINUTES = [5, 10, 15]

export const AgentTypes: Record<string, string> = {
	LIFESTYLE_COACH: "COACH",
	DOCTOR: "DOCTOR",
	SF_PSYCHIATRIST: "SF_PSYCHIATRIST",

}

export const TEXT_BLOG_DEEPLINK_TEMPLATE = "curefit://freemiumblogdetailspage?blogId=id"
export const VIDEO_BLOG_OR_INFO_BITE_DEEPLINK_TEMPLATE = "curefit://singlevideoplayer?videoUrl=$videoUrl&title=$title&thumbnailUrl=$thumbnailUrl"
export const DEFAULT_BLOG_LINK_TEXT = "Select a table row to create blog link"
export const DEFAULT_INFO_BITE_LINK_TEXT = "Select a table row to create Info Bite link"

export const pdfAttachmentType: { [key: string]: string } = {
	EMAIL_ATTACHMENT: "EMAIL_PRESCRIPTION",
	PRINT_ATTACHMENT: "PRINT_PRESCRIPTION",
	EMAIL_PLAN_ATTACHMENT: "EMAIL_PLAN",
	PRINT_PLAN_ATTACHMENT: "PRINT_PLAN",
}

export const pdfAttachmentAction: { [key: string]: string } = {
	EMAIL: "EMAIL",
	PRINT: "PRINT",
}

export const TITRATION_POLICY_DOC_LINK = "https://docs.google.com/document/d/1ZOPf-eqnUn0_6xAajxty8SHPPgFQykmcUc9SVJFPM1k"

export enum RequestCategory {
	ALTERNATE_CONNECT = "ALTERNATE_CONNECT",
	TASK_RESCHEDULE_DATE = "TASK_RESCHEDULE_DATE",
	LONG_LEAVE = "LONG_LEAVE",
}

export enum DocumentTypes {
	DIAGNOSTICS = "Diagnostics",
	PRESCRIPTIONS = "Prescriptions",
	KICKSTARTER = "Kickstarter",
	LAB_REPORTS = "Lab Report",
}

export enum ReportTypes {
	DIAGNOSTIC_REPORT = "DIAGNOSTIC_REPORT",
}

export enum CgmDeviceStatus {
	AGM_ORDERED = "AGM_ORDERED",
	AGM_DELIVERED = "AGM_DELIVERED",
	AGM_STARTED = "AGM_STARTED",
	AGM_FIRST_READING_UPLOADED = "AGM_FIRST_READING_UPLOADED",
	AGM_READING_UPLOADED = "AGM_READING_UPLOADED",
	AGM_FINAL_READING_UPLOADED = "AGM_FINAL_READING_UPLOADED",
	AGM_CRASHED = "AGM_CRASHED",
	AGM_ENDED = "AGM_ENDED",
}

export const AllowedCgmStates = [
	CgmDeviceStatus.AGM_STARTED,
	CgmDeviceStatus.AGM_FIRST_READING_UPLOADED,
	CgmDeviceStatus.AGM_READING_UPLOADED,
	CgmDeviceStatus.AGM_FINAL_READING_UPLOADED,
	CgmDeviceStatus.AGM_CRASHED,
	CgmDeviceStatus.AGM_ENDED,
]

export const USER_LIFESTYLE_MAP: Record<string, string> = {
	SEDENTARY_LIGHT: "Sedentary/Light Activity",
	MODERATE: "Moderate Activity",
	VIGOROUS: "Vigorous Activity",
}

export enum ANTD_SORT_ORDER {
	ascend = "ascend",
	descend = "descend",
}

export enum ActivityCategory {
	WORKOUT = "WORKOUT",
	EXERCISE = "EXERCISE",
	MEDICATION = "MEDICATION",
	MEDITATION = "MEDITATION",
	GENERIC = "GENERIC",
	EAT = "EAT",
	MEAL = "MEAL",
	MEDICINE = "MEDICINE",
	MIND = "MIND",
	SLEEP = "SLEEP",
}

export enum ACTIVITY_TYPES {
	NUTRITION = "NUTRITION",
	FITNESS = "FITNESS",
	MEDICATION = "MEDICATION",
	SLEEP = "SLEEP",
	MINDFULNESS = "MINDFULNESS",
	INSIGHTS = "INSIGHTS",
}

export enum GoalDataSource {
	AMBROSIA = "AMBROSIA",
	METRIC = "METRIC",
}

export enum GOAL_TARGET_TYPES {
	RANGE = "RANGE",
	LESS_THAN = "LESS_THAN",
	GREATER_THAN = "GREATER_THAN",
}

export enum HbA1CProgressStatus {
	PROGRESS = "Progress",
	NO_PROGRESS = "No Progress",
	NA = "NA",
}

export const AppVersionKey = "AppVersion"
export enum TimeFilterRanges {
	_7_DAYS = "7 Days",
	_1_MONTH = "1 Month",
	_3_MONTH = "3 Month",
	_6_MONTHS = "6 Months",
	ALL_TIMES = "All Times",
	CUSTOM = "Custom Range",
}

export const TIME_FILTERS: IStaticDataValue[] = [
	{ displayValue: "7 Days", internalValue: TimeFilterRanges._7_DAYS },
	{ displayValue: "1 Month", internalValue: TimeFilterRanges._1_MONTH },
	{ displayValue: "3 Months", internalValue: TimeFilterRanges._3_MONTH },
	{ displayValue: "6 Months", internalValue: TimeFilterRanges._6_MONTHS },
	{ displayValue: "All Times", internalValue: TimeFilterRanges.ALL_TIMES },
	{ displayValue: "Custom Range", internalValue: TimeFilterRanges.CUSTOM },
]

export const ORION_S3_IMAGES_FIRE = ORION_S3_BASE_URL_V1 + "/fire.svg"
export const ORION_S3_IMAGES_THUNDER = ORION_S3_BASE_URL_V1 + "/thunder.svg"
export const ORION_S3_IMAGES_HEART = ORION_S3_BASE_URL_V1 + "/heart.svg"
export const ORION_S3_IMAGES_STEPS = ORION_S3_BASE_URL_V1 + "/steps.svg"
export const ORION_S3_IMAGES_MOON = ORION_S3_BASE_URL_V1 + "/moon.svg"

export enum PatientRelationships {
	SELF = "SELF",
}

export enum FitnessLevels {
	BEGINNER = "BEGINNER",
	INTERMEDIATE = "INTERMEDIATE",
	HARD = "HARD",
}

export enum UserAssignedExperimentType {
	ALL = "ALL",
	ONGOING = "ONGOING",
	PAST = "PAST",
}

export enum ExperimentCategories {
	ALL = "All",
	NUTRITION = "Nutrition",
	FITNESS = "Fitness",
	SLEEP = "Sleep",
	ALCOHOL = "Alcohol",
}

export enum ExperimentStatus {
	JOINED = "JOINED",
	COMPLETED = "COMPLETED",
	ABORTED = "ABORTED",
	PAUSED = "PAUSED",
}

export enum FitnessPlanType {
	FITNESS = "FITNESS",
	MINDFULNESS = "MINDFULNESS",
}

export enum FULFILLMENT_API_KEY {
	SUGARFIT_BACKEND = "SUGARFIT_BACKEND",
	SUGARFIT_CMT = "SUGARFIT_CMT",
}

export const OPS_BOOKING_CONSTANTS: Record<string, string> = {
	CGM_DELIVERY: "CGM Delivery",
	CGM_INSTALLATION: "CGM Installation",
	CGM_READING: "CGM Reading",
}

export enum LogInsightMarkers {
	MEAL_LOG = "MEAL_LOG",
	CGM_DATA = "CGM_DATA",
	SMBG_LOG = "SMBG_LOG",
	INTERVENTION_LOG = "INTERVENTION_LOG",
	FITNESS_LOG = "FITNESS_LOG",
	DIAGNOSTIC_REPORT = "DIAGNOSTIC_REPORT",
	PATIENT_DOCUMENT = "PATIENT_DOCUMENT",
	DOCTOR_CONSULTATION = "DOCTOR_CONSULTATION",
	FITNESS_DEVICE_LOG = "FITNESS_DEVICE_LOG",
}

export enum ChatMediaType {
	IMAGE = "IMAGE",
	VIDEO = "VIDEO",
	AUDIO = "AUDIO",
	DOCUMENT = "DOCUMENT",
	VOICE = "VOICE",
}

export enum DietPlanTemplateFlow {
	PLAN_CREATION = "PLAN_CREATION",
	PLAN_EDIT_VIEW = "PLAN_EDIT_VIEW",
	TEMPLATE_CREATION = "TEMPLATE_CREATION",
	TEMPLATE_FOR_PLAN_EDIT_VIEW = "TEMPLATE_FOR_PLAN_EDIT_VIEW",
	TEMPLATE_EDIT_VIEW = "TEMPLATE_EDIT_VIEW",
	DEFAULT_TEMPLATE_EDIT_VIEW = "DEFAULT_TEMPLATE_EDIT_VIEW",
}

export enum RCAReportSearchStatus {
	ALL = "ALL",
	FIRST_RCA_PENDING = "FIRST_RCA_PENDING",
	CLOSED = "CLOSED",
	FOLLOW_UP_OVERDUE = "FOLLOW_UP_OVERDUE",
	FOR_COACH_REVIEW = "FOR_COACH_REVIEW",
	OPEN = "OPEN",
}

export enum RCAClinicalProgressFilter {
	PROGRESS = "Progress",
	NO_PROGRESS = "No-Progress",
	NA = "NA",
}

export enum RCAProgressTags {
	PROGRESS = "PROGRESS",
	NO_PROGRESS = "NO_PROGRESS",
	NA = "NA",
	HBA1C_INCREASED = "HBA1C_INCREASED",
	HBA1C_DECREASED = "HBA1C_DECREASED",
	MEDICINE_SCORE_INCREASED = "MEDICINE_SCORE_INCREASED",
}

export enum RCAPatientListSortBy {
	DIAGNOSTIC_REPORT_DATE = "DIAGNOSTIC_REPORT_DATE",
	FOLLOW_UP_DATE = "FOLLOW_UP_DATE",
	DEFAULT_PROGRESS_REPORT_SORT = "DEFAULT_PROGRESS_REPORT_SORT",
	WELCOME_CALL_DATE = "WELCOME_CALL_DATE",
}

export enum RCAReportStatus {
	REVIEW_PENDING = "REVIEW_PENDING",
	REVIEWED = "REVIEWED",
	EXPIRED = "EXPIRED",
}

export enum FileType {
	AUDIO = "AUDIO",
	VIDEO = "VIDEO",
	IMAGE = "IMAGE",
}

export enum ConsultationType {
	COACH_EDIT = "COACH_EDIT",
	COACH_ONGOING = "COACH_ONGOING",
	DOCTOR_ONGOING = "DOCTOR_ONGOING",
}

export const TIER_2_WC1_PPT = "https://docs.google.com/presentation/d/1WBq12PwbnC2gj8kTLfNNBxCRPHim23NBiXKP-u108ek/edit#slide=id.p1"

export const IS_VOIP_SESSION_ACTIVE = "IS_VOIP_SESSION_ACTIVE"
export const ACTIVE_VOIP_SESSION_ID = "ACTIVE_VOIP_SESSION_ID"
export const ACTIVE_VOIP_USER_ID = "ACTIVE_VOIP_USER_ID"
export const ONGOING_VC_SESSION_ID = "ONGOING_VC_SESSION_ID"
export const ACTIVE_VOIP_INSTANCE_ID = "ACTIVE_VOIP_INSTANCE_ID"

export const AUTO_END_VOIP_CALL_DUE_TO_NO_ANSWER = "AUTO_END_VOIP_CALL_DUE_TO_NO_ANSWER"
export const VIDEO_BG_INDEX = "VIDEO_BG_INDEX"

export const rashiAtrributesMapping = [
	{
		rashiAttribute: "fullname",
		templateParameter: "customerName",
	},
	{
		rashiAttribute: "lifestyle_coach_name",
		templateParameter: "coachName",
	},
]

export const PSYCHOLOGIST_SUB_SERVICE_TYPE = "SF_PSYCHIATRIST"


export const OFFLINE_DOCTOR_CONSULT_PRODUCT_CODE = "SFEXP001"

export enum RenewalCrmType {
	POST_EXPIRY = "POST_EXPIRY",
	PRE_EXPIRY = "PRE_EXPIRY",
}

export const CGM_RECALL_SUMMARY_TAB = "CGM_RECALL_SUMMARY_TAB"
export const GoalsToIgnoreForGlpScript = ["Fasting Glucose", "Postprandial Glucose", "Hba1c"]
